import styled from "styled-components";
import { Style } from "../../styles";

const MenuSection = styled.div`
  margin-bottom: ${Style.spacing.x1_5};
`

export default MenuSection